import { Box, Typography, useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";
import { tv } from "tailwind-variants";

import type { PagePreview } from "~/core";

type InfoPageListItemProps = {
  page: PagePreview;
  isActive: boolean;
  getPageUrl: string;
};

const InfoPageListItemStyles = tv({
  base: "text-[var(--fontSize-mobile-medium-body)] leading-[var(--lineHeight-mobile-small-body)] md:leading-[var(--lineHeight-desktop-large-body)] md:text-[var(--fontSize-desktop-large-body)]  md:font-semibold  ",
  variants: {
    active: {
      true: "text-[var(--colors-text-primary-hovered)] bg-[var(--colors-surface-neutral-default)]  border-l-4 border-[var(--colors-border-selected)] !text-[var(--colors-text-primary-hovered)]",
      false: "bg-[var(--colors-surface-neutral-light)]",
    },
  },
  defaultVariants: {
    active: false,
  },
});

export const InfoPageListItem: FC<InfoPageListItemProps> = ({
  page,
  isActive,
  getPageUrl,
}) => {
  const { Link } = useUiKitComponents();

  return (
    <Link
      href={getPageUrl}
      className={InfoPageListItemStyles({ active: isActive })}
    >
      <Box p={{ px: 16, py: 12 }} md={{ p: { px: 32, py: 12 } }}>
        <Typography size="medium" as="span">
          {page?.seo?.translations?.[0]?.title}
        </Typography>
      </Box>
    </Link>
  );
};
